module.exports = __webpack_public_path__ + "img/339-22ad94.png";